/** Today's date on this device as YYYY-MM-DD. Local, not UTC: a traveler checking
 *  the handbook at 11pm should still see today, not tomorrow's tab. */
export function localISODate(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * Which day tab the handbook should open on.
 *   - today has a tab            -> that tab
 *   - the trip hasn't started    -> the first day
 *   - today has no tab, but days
 *     are still to come          -> the next upcoming day
 *   - the trip is over           -> the first day
 * Days without a date are ignored. With no dated day at all it is the first tab.
 */
export function initialDayIndex(days: { date?: string | null }[], today: string): number {
  let nextIdx = -1;
  for (let i = 0; i < days.length; i++) {
    const date = days[i].date;
    if (!date) continue;
    if (date === today) return i;
    if (date > today && (nextIdx === -1 || date < (days[nextIdx].date as string))) nextIdx = i;
  }
  return nextIdx === -1 ? 0 : nextIdx;
}
